import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7a6.003 6.003 0 0 1-4 5.659V13h2v2H4v-2h2v-.341A6 6 0 1 1 14 7ZM8 8c.025 0 .05 0 .075-.003L9 9.068 10.068 8l-1.07-.925a1 1 0 0 0-1.216-1.05l-1.643-1.42-.534.534L7.024 6.78A1 1 0 0 0 8 8Z"
    />
  </svg>
);
export default IconPressureFilledSizeS;
